module.exports = __webpack_public_path__ + "static/media/6.9794f64c.jpeg";